<div class="sheet-backdrop" (click)="onFechar()"></div>

<div class="sheet">
  <div class="sheet-handle"></div>

  <div class="modal-header">
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h2 class="modal-title">{{ produto ? produto.descricao : 'Adicionar produto' }}</h2>
      @if (produto) {
      <span class="modal-subtitle">{{ produto.codigoSku ? 'SKU: ' + produto.codigoSku : (produto.gtinEan ? 'EAN: ' +
        produto.gtinEan : '') }}</span>
      }
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn" (click)="onFechar()" aria-label="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <div class="sheet-body">
    @if (permiteSelecionarProduto) {
    <app-select-pesquisavel [control]="produtoControl" [apiUrl]="produtoApiUrl"
      [extraParams]="{ apenasControlaEstoque: true }" [preloadedOptions]="produtoPreload" idField="idProduto"
      nameField="descricao" label="Produto" [subscriptSizing]="'dynamic'" [disabled]="isReadOnly || isCarregandoProduto"
      (selectionChange)="onProdutoSelecionado($event)">
    </app-select-pesquisavel>
    }

    @if (isCarregandoProduto) {
    <div class="sheet-carregando">
      <span>Carregando produto...</span>
    </div>
    }

    @if (produto && !isCarregandoProduto) {
    <!-- Local -->
    @if (locaisDisponiveis.length > 1) {
    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
      <mat-label>Local de estoque</mat-label>
      <mat-select [(ngModel)]="idLocalizacaoEstoque" [disabled]="isReadOnly" (selectionChange)="onLocalChange()">
        @for (l of locaisDisponiveis; track l.idLocalizacaoEstoque) {
        <mat-option [value]="l.idLocalizacaoEstoque">{{ l.nome }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    } @else if (locaisDisponiveis.length === 1) {
    <div class="sheet-local-unico">
      <mat-icon>place</mat-icon>
      <span>{{ locaisDisponiveis[0].nome }}</span>
    </div>
    }

    <div class="sheet-resumo">
      <div>
        <small>Saldo sistema</small>
        <strong>{{ saldoSistema | abnt:'quantidade' }}</strong>
      </div>
      <div>
        <small>Contagem atual</small>
        <strong>{{ quantidadeAtualSalva == null ? '—' : (quantidadeAtualSalva | abnt:'quantidade') }}</strong>
      </div>
      <div>
        <small>Ajuste previsto</small>
        <strong [class.ajuste-negativo]="(ajustePrevisto ?? 0) < 0" [class.ajuste-positivo]="(ajustePrevisto ?? 0) > 0">
          {{ ajustePrevistoTexto | abnt:'quantidade'}}
        </strong>
      </div>
    </div>

    <!-- Quantidade simples -->
    @if (usaQuantidadeSimples) {
    <div class="sheet-qtd">
      <span class="sheet-label">Quantidade contada</span>
      <div class="sheet-stepper">
        <button mat-icon-button type="button" (click)="decrementar()" [disabled]="isReadOnly" aria-label="Diminuir">
          <mat-icon>remove</mat-icon>
        </button>
        <input type="text" inputmode="decimal" [(ngModel)]="quantidade" [currencyMask]="quantidadeMask"
          [readonly]="isReadOnly" />
        <button mat-icon-button type="button" (click)="incrementar()" [disabled]="isReadOnly" aria-label="Aumentar">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    }

    @if (usaLotes || usaSeries) {
    <div class="sheet-rastreabilidade">
      <div class="sheet-rastreabilidade__info">
        <div class="sheet-rastreabilidade__titulo">
          <mat-icon>{{ usaLotes ? 'inventory_2' : 'qr_code_2' }}</mat-icon>
          <span>{{ usaLotes ? 'Controle de lotes' : 'Controle de séries' }}</span>
        </div>
        <span class="sheet-rastreabilidade__total">
          Quantidade contada:
          <strong>{{ quantidadeFinal | abnt:'quantidade' }}</strong>
        </span>
        <span class="sheet-rastreabilidade__status" [class.confirmado]="rastreabilidadeConfirmada"
          [class.pendente]="!rastreabilidadeConfirmada">
          <span class="status-point"></span>
          {{ rastreabilidadeConfirmada ? 'Contagem confirmada' : 'Contagem pendente' }}
        </span>
      </div>

      <button mat-stroked-button class="btn-secondary sheet-rastreabilidade__acao" type="button"
        (click)="abrirRastreabilidade()">
        <mat-icon class="material-symbols-outlined">data_info_alert</mat-icon>
        {{ isReadOnly ? 'Visualizar' : (usaLotes ? 'Informar lotes' : 'Informar séries') }}
      </button>
    </div>
    }
    }
  </div>

  <div class="sheet-footer">
    <button mat-stroked-button class="btn-secondary" type="button" (click)="onFechar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" type="button" (click)="onConfirmar()"
      [disabled]="isReadOnly || !podeAdicionar">
      Adicionar
    </button>
  </div>
</div>